import React from 'react'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'


class Cartsv extends React.PureComponent {
  render() {
    return (
      <div>

        <p>
          SV Cartsv Component
        </p>
      
       
     <h1>
        Blue Taco 
        <Badge bg="secondary" as={Button}>
          New SVCArt
        </Badge>
      </h1>
        
      </div>
    )
  }
}

export default Cartsv
